@if (isLoaded) {
  <div class="row align-items-stretch mt-2">
    @for (draft of drafts; track draft) {
      <div class="col-12 col-lg-6 mb-3">
        <app-order-draft-card
          [draft]="draft"
          [showCreate]="true"
          [showDelete]="true"
          [contactName]="getContactName(draft.portOrder.contactId)"
          [instancename]="getInstancename(draft.portOrder.applianceId)"
          (delete)="onDeleteDraft($event)"
          (continue)="onContinueDraft($event)">
        </app-order-draft-card>
      </div>
    }
  </div>
}

@if (isLoaded && drafts.length === 0) {
  <div class="row mt-3 red card-h1">
    <div class="col">
      <span>{{'no_drafts' | i18next}}</span>
    </div>
  </div>
}
